import { render } from "./TemplateSurveyScoresExplorer.vue?vue&type=template&id=948f1474"
import script from "./TemplateSurveyScoresExplorer.vue?vue&type=script&lang=js"
export * from "./TemplateSurveyScoresExplorer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__